<template>
  <div class="af3-shortcodes-single-detail-component">
    <div class="af3-shortcodes-single-detail-component-gallery">
      <single-gallery-component
        v-if="floor_plan.image"
        :options="options"
        :floor_plan="floor_plan"
      ></single-gallery-component>

      <!-- Special Text Overlay -->
      <div class="af3-floor-plan-card-special-text" v-if="floor_plan.current_special_text">
        {{ floor_plan.current_special_text }}
      </div>

      <!-- sold out overlay -->
      <div class="af3-shortcodes-single-detail-component-sold-out-banner" v-if="floor_plan.is_sold_out">
        Sold Out
      </div>
    </div>

    <div class="af3-shortcodes-single-detail-component-content">
      <div class="af3-shortcodes-single-detail-component-content-details">
        <h1 v-html="floor_plan.title"></h1>
        
        <div class="af3-shortcodes-single-detail-container">
          <div>
            <span class="detail-label">{{ options.single_floor_plan_bedrooms_label }}</span>
            <span class="detail-value">{{ bedroom_string(floor_plan.bedrooms) }}</span>
          </div>

          <div>
            <span class="detail-label">{{ options.single_floor_plan_bathrooms_label }}</span>
            <span class="detail-value">{{ floor_plan.bathrooms }}</span>
          </div>

          <div>
            <span class="detail-label">{{ options.single_floor_plan_square_feet_label }}</span>
            <span class="detail-value">{{ floor_plan.size_max }} SQ FT</span>
          </div>

          <!-- Price block: hidden entirely when there's no real price and no fallback message,
               so we don't render an orphan "Starting at" label or "$0" / "-$1" placeholder. -->
          <div v-if="options.single_floor_plan_show_pricing && (pricingOverrideText || pricingUnavailableText || hasValidPrice)">
            <span class="detail-label">{{ options.single_floor_plan_price_label }}</span>
            <!-- Global override (admin-set) wins over everything. -->
            <span class="detail-value" v-if="pricingOverrideText">{{ pricingOverrideText }}</span>
            <!-- Yardi fallback message in place of price (e.g. "Call for pricing"). -->
            <span class="detail-value" v-else-if="pricingUnavailableText">{{ pricingUnavailableText }}</span>
            <!-- Real published rent. -->
            <span class="detail-value" v-else v-dollar-format="floor_plan.price_min"></span>
          </div>
        </div>

        <div class="af3-shortcodes-single-detail-component-cta-container">
          <a v-if="floor_plan.availability_url" 
             :href="floor_plan.availability_url" 
             target="_blank">
            {{ options.floor_plans_loop_apply_button_label }}
          </a>

          <!-- Tour Button - Custom Link -->
          <template v-if="options.floor_plans_loop_custom_tour_link">
            <a :href="options.floor_plans_loop_custom_tour_link"
               :target="options.floor_plans_loop_custom_tour_link !== '#tour-popup' ? '_blank' : undefined">
              {{ options.floor_plans_loop_schedule_tour_button_label }}
            </a>
          </template>

          <!-- Tour Button - Popup -->
          <template v-else>
            <a v-if="options.tour_popup_enabled" 
               href="#tour-popup" 
               x-data="" 
               x-on:click.prevent="$store.tourPopup.toggle()">
              {{ options.floor_plans_loop_schedule_tour_button_label }}
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { defineComponent, computed } from 'vue';
import SingleGalleryComponent from './SingleGalleryComponent.vue';

export default defineComponent({
    components: {SingleGalleryComponent},
   
    props: {
        options: {
            type: Object,
            required: true
        },
        floor_plan: {
            type: Object,
            required: true
        }
    },

    setup(props) {
        const bedroom_string = (bedrooms) => {
            if (bedrooms == 0) {
                return 'Studio';
            } else {
                return bedrooms;
            }
        };

        const pricingOverrideText = computed(() => {
            const override = props.options.override_pricing || props.floor_plan.has_pricing_override;
            return override && String(override).trim() !== '' ? override : null;
        });

        // Yardi "Pricing Unavailable" fallback text. Empty/missing means
        // "no fallback configured" — the price block is hidden in that case.
        const pricingUnavailableText = computed(() => {
            const fallback = props.floor_plan.pricing_unavailable_text;
            return fallback && String(fallback).trim() !== '' ? fallback : null;
        });

        // Whether price_min is a real positive number worth rendering. Guards
        // against '$0' / '-$1' from empty / non-positive price_min values.
        const hasValidPrice = computed(() => {
            const value = Number(props.floor_plan.price_min);
            return !Number.isNaN(value) && value > 0;
        });

        return {
            bedroom_string,
            pricingOverrideText,
            pricingUnavailableText,
            hasValidPrice
        };
    },


  
  
});
</script>